import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import logoSped from "../assets/images/logo-sped.png";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer d-xxl-block d-none">
                <Container fluid>
                    <Row>
                        <Col sm={6} className='footer-version'>
                            {new Date().getFullYear()} © Openlink. v2.0.0
                        </Col>
                        <Col sm={6} className='footer-logo'>
                            <div className="text-sm-end d-sm-block">
                                <span className="logo-lg">
                                    <img src={logoSped} alt="" height="25" />
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;